(function() {
    'use strict';

    angular.module('settings', [
            'ui.router',

            'settings.constants',
            'settings.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'variablePermissionsConst', 'settingPermissionsConst', 'systemLogPermissionsConst', 'clientcontactPermissionsConst', 'faqPermissionsConst', 'bannerPermissionsConst', 'translationPermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, variablePermissionsConst, settingPermissionsConst, systemLogPermissionsConst, clientcontactPermissionsConst, faqPermissionsConst, bannerPermissionsConst, translationPermissionsConst) {

        $stateProvider
            .state('layout.setting', {
                abstract: true,
                url: '/settings',
                data: {
                    title: 'Ustawienia',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.setting.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/setting-list/setting-list.html',
                        controller: 'SettingListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: settingPermissionsConst.view
                }
            })
            .state('layout.setting.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/setting-create/setting-create.html',
                        controller: 'SettingCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: settingPermissionsConst.add
                }
            })
            .state('layout.setting.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/setting-update/setting-update.html',
                        controller: 'SettingUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: settingPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.systemlog', {
                abstract: true,
                url: '/systemlogs',
                data: {
                    title: 'Logi systemowe',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.systemlog.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/system-log-list/system-log-list.html',
                        controller: 'SystemLogListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: settingPermissionsConst.view
                }
            });

        $stateProvider
            .state('layout.variable', {
                abstract: true,
                url: '/variables',
                data: {
                    title: 'Zmienne do praflightu',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.variable.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/variable-list/variable-list.html',
                        controller: 'VariableListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: variablePermissionsConst.view
                }
            });

        $stateProvider
            .state('layout.messages', {
                abstract: true,
                url: '/messages',
                data: {
                    title: 'Sprawy',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.messages.list', {
                url: '/list?responsible_person',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/messages-list/messages-list.html',
                        controller: 'MessagesListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: clientcontactPermissionsConst.view
                }
            })
            .state('layout.messages.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/messages-create/messages-create.html',
                        controller: 'MessagesCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: clientcontactPermissionsConst.add
                }
            })
            .state('layout.messages.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/messages-update/messages-update.html',
                        controller: 'MessagesUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: clientcontactPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.translation', {
                abstract: true,
                url: '/translations',
                data: {
                    title: 'Tłumaczenia',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.translation.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/translation-list/translation-list.html',
                        controller: 'TranslationListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: translationPermissionsConst.view
                }
            })
            .state('layout.translation.models-list', {
                url: '/models-list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/translation-models-list/translation-models-list.html',
                        controller: 'TranslationModelsListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: translationPermissionsConst.view
                }
            });

        $stateProvider
            .state('layout.faq', {
                abstract: true,
                url: '/faqs',
                data: {
                    title: 'Faq',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.faq.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/faq-list/faq-list.html',
                        controller: 'FaqListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: faqPermissionsConst.view
                }
            })
            .state('layout.faq.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/faq-create/faq-create.html',
                        controller: 'FaqCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: faqPermissionsConst.add
                }
            })
            .state('layout.faq.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/faq-update/faq-update.html',
                        controller: 'FaqUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: faqPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.banner', {
                abstract: true,
                url: '/banners',
                data: {
                    title: 'Baner',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.banner.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/banner-list/banner-list.html',
                        controller: 'BannerListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: bannerPermissionsConst.view
                }
            })
            .state('layout.banner.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/banner-create/banner-create.html',
                        controller: 'BannerCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: bannerPermissionsConst.add
                }
            })
            .state('layout.banner.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/banner-update/banner-update.html',
                        controller: 'BannerUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: bannerPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.dataImport', {
                url: '/data-import',
                views: {
                    'main@layout': {
                        templateUrl: 'app/settings/views/data-import/data-import.html',
                        controller: 'DataImportController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'Import danych',
                    permission: userPermissionsConst.user
                }
            });
    }
})();
